// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"8818064b","56":"8ede1013","57":"e874ad19","124":"75bb7197","453":"23eaac07","470":"060e4d9b","585":"fa1909bc","660":"20ec9f52","697":"0e26c05d","712":"42801944","729":"2875e6a8"}[chunkId] + ".chunk.js";
};